import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetLiftPositionOptions = (
  context: ProductBuilderMachineContext,
) => string[];

export const getLiftPositionOptions: GetLiftPositionOptions = context => {
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];
  const {
    metafields: { lift_position },
  } = baseProduct;
  return lift_position ? lift_position : [];
};
